module.exports = __webpack_public_path__ + "static/led-light-bulb-b6b97e772956d5ea7199ca5bc65cd572.png";